import {
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
} from '@edenredespana/oreneta'

export const AutoEnrollmentStep0 = (): JSX.Element => {
  return (
    <OreStack placeContent="stretch" space="large">
      <OreCardContainer>
        <OreCardWrapper>
          <OreStack placeContent="stretch" space="xlarge"></OreStack>
        </OreCardWrapper>
        <OreCardActions></OreCardActions>
      </OreCardContainer>
    </OreStack>
  )
}
